import axios from '@/http/index';

const base = '';
// 获得订单支付页面需要的数据
export const getOrderBillingMsg = (param) => axios.get(`${base}/erp/customerOrder/getOrderBillingMsg`, param).then((res) => res.data);
// 获得扫码支付二维码信息
export const getQRCode4ScanPay = (param) => axios.get(`${base}/erp/customerOrder/getQRCode4ScanPay`, param).then((res) => res.data);
// 获得扫码支付状态
export const getScanPayStatus = (params) => axios.get(`${base}/erp/customerOrder/getScanPayStatus`, params).then((res) => res.data);
// （结算）获得赊账二维
export const getQRCode4Credit = (params) => axios.get(`${base}/erp/customerOrder/getQRCode4Credit`, params).then((res) => res.data);
// 支付成功后保存订单
export const toPay = (params) => axios.post(`${base}/erp/customerOrder/toPay2`, params).then((res) => res.data);
// 打印
export const printOrder = (params) => axios.get(`${base}/erp/print/printOrder`, params).then((res) => res.data);
// 赊账授权非现场授权发送短信
export const sendMsg4Serve = (params) => axios.get(`${base}/erp/customerOrder/sendMsg4Serve`, params).then((res) => res.data);
// 是否设置了打印机
export const hasPrintSet = (params) => axios.get(`${base}/erp/print/hasPrintSet`, params).then((res) => res.data);
// （魔盒）获得魔盒列表
export const getMagicBoxList = (params) => axios.get(`${base}/erp/customerOrder/getMagicBoxList`, params).then((res) => res.data);
// （魔盒）魔盒订单推送
export const receptionOrder = (params) => axios.get(`${base}/erp/customerOrder/receptionOrder`, params).then((res) => res.data);
// （结算）扫码支付
export const barCodePay = (params) => axios.get(`${base}/erp/customerOrder/barCodePay`, params).then((res) => res.data);
// （结算）扫码支付--获取订单号
export const getOrderCode = (params) => axios.get(`${base}/erp/payInfo/getOrderCode`, params).then((res) => res.data);
// （结算）扫码支付--获取支付状态
export const newGetScanPayStatus = (params) => axios.get(`${base}/erp/payInfo/getScanPayStatus`, params).then((res) => res.data);
// （结算）扫码支付--3.6.0
export const newBarCodePay = (params) => axios.get(`${base}/erp/payInfo/barCodePay`, params).then((res) => res.data);
// 获取商家可支付方式：默认支付(0:未设置 2:通联支付,4:微信,5:支付宝,6:(包括支付宝，微信))
export const getPaySet = (params) => axios.get(`${base}/erp/payInfo/getPaySet`, params).then((res) => res.data);

// (3.8.0)获得店铺结算设置信息
export const getPayCodeList = (params) => axios.get(`${base}/erp/payInfo/getPayTypeSetList`, params).then((res) => res.data);

// （5.1）扫码和魔盒支付前提交订单信息
export const toPayBefore = (params) => axios.post(`${base}/erp/customerOrder/toPayBefore`, params).then((res) => res.data);

// 获得新增会员跳转链接
export const getMemberUrl = (params) => axios.get(`${base}/erp/member/getMemberUrl`, params).then((res) => res.data);

// （魔盒）魔盒订单推送
export const payQrOrderPush = (params) => axios.post(`${base}/erp/payInfo/payQrOrderPush`, params).then((res) => res.data);

// (6.2)取消smartBox推送
export const cancelSmartBoxPush = (params) => axios.get(`${base}/erp/payInfo/cancelSmartBoxPush`, params).then((res) => res.data);
